import * as React from "react";
import Chart from "react-apexcharts";

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        colors: ["#f05a28"],
        chart: {
          id: "basic-bar",
          events: {
            click: () => this.props.swapChart("barChart")
          }
        },
        xaxis: {},
        yaxis: {
          title: {
            text: "Состояние"
          }
        }
      },
      series: [
        {
          data: []
        }
      ]
    };
  }

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.series !== this.props.series) {
      this.reload();
    }
  }

  reload = () => {
    const newSeries = [],
      data = this.props.series;
    newSeries.push({ data, name: "Состояние:" });
    this.setState({
      series: newSeries,
      options: {
        ...this.state.options,
        xaxis: {
          title: {
            text: "Время"
          },
          labels: {
            show: false
          },
          categories: this.props.labels
        }
      }
    });
  };

  render() {
    return (
      <Chart
        options={this.state.options}
        series={this.state.series}
        type="line"
        height="300"
      />
    );
  }
}

export default LineChart;
